import _ from 'underscore';
import { TerritoryActions } from '../actions/territoryActions';
import { UserActions } from '../actions/userActions';
import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';
import { userStore } from '../stores/user';
import { storeUtils } from './util';

const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();

//the list of all territories
var _territories = [];
//the selected territory
var _selectedTerritory = 0;
//the selected desk details
var _territoryIsSelected = false;
var _isLoading = false;

var dispatchToken = dispatcher.register(function (action) {

    //this action comes from the dispatcher
    switch (action.type) {

        case ActionTypes.TERRITORY_DETAIL_LOADING:
            _isLoading = true;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        case ActionTypes.USER_CHANGED:
            if (action.role.indexOf(Constants.Roles.DISPATCHER) === 0) {
                _selectedTerritory = '1';
                _territoryIsSelected = true;
                // ServerActions.getTerritoryDetail(_selectedTerritory);
            }
            else {
                _selectedTerritory = '0';
                _territoryIsSelected = false;
            }
            _events.trigger(ActionTypes.CHANGE_EVENT);

            break;

        case ActionTypes.SET_USER_ROLE:
            if (action.user.isDispatcherDesk) {
                //if they are a dispatcher, default their territory and lata
                _selectedTerritory = "DS" + userStore.getUser().machineHost.substring(3, 6).replace(/^0*/, '');

                /**This post describes that making a call to an action from a store is OK if the action initiator is a non-human interaction
                 * http://stackoverflow.com/questions/25630611/should-flux-stores-or-actions-or-both-touch-external-services
                 */
                //Trigger territory changed event to get subs and default print lata
                setTimeout(function () {
                    TerritoryActions.territoryChanged(_selectedTerritory, true);
                }, 1);
            }

            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        case ActionTypes.TERRITORY_LIST_LOADED:
            _territories = action.territories;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        case ActionTypes.TERRITORY_CHANGED:
            _selectedTerritory = action.selectedTerritory;
            //_subSelected = false;
            if (action.selectedTerritory === '0' || action.selectedTerritory === '1')
                _territoryIsSelected = false;
            else {
                _territoryIsSelected = true;

                if (userStore.isDispatcher()) {
                    let details = _.findWhere(_territories, { name: action.selectedTerritory });
console.log("details", details);
                    const lata = details.printLata;

                    setTimeout(function () {
                        UserActions.lataChanged(lata);
                    }, 1);
                }
            }
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        case ActionTypes.TERRITORY_DETAILS_LOADED:
            _isLoading = false;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        case ActionTypes.TERRITORY_DETAIL_FAILED_LOAD:
            _isLoading = false;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        default:
        //no op
    }
});//end of dispatch token

//public api
export const territoryStore = {
    dispatchToken,
    subscribe: _events.on,
    unsubscribe: _events.off,

    getTerritoryList: function () {
        return _territories
    },
    getSelectedTerritory: function () {
        return _selectedTerritory;
    },
    isTerritorySelected: function () {
        return _territoryIsSelected;
    },
    isLoading: function () {
        return _isLoading;
    }
};
